import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import socket from "../socket";
import { useNavigate } from "react-router-dom";
import Image from "../assets/main-image.png";
import { Link } from "react-router-dom";

const { v4: uuidv4 } = require("uuid");

const MainContainer = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #000;
  .main-image {
    float: right;
  }
  .main-image img {
    width: 90%;
    height: 600px;
  }
  .main-title {
    font-size: 2.5rem;
    margin: 0;
    width: 600px;
    height: 50vh;
    font-family: "Comic Neue", cursive;
    padding: 80px;
    background-image: linear-gradient(
      to right,
      #df0073,
      #eb34d9,
      #693df0,
      #2457ff
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .main-input {
    margin: 20px 20px 20px 80px;
    width: 240px;
    height: 40px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid #ef5da8;
    color: #eef8f7;
    text-align: center;
    font-family: "Comic Neue", cursive;
  }
  .main-input:focus {
    outline: none;
  }
  .join-btn {
    width: 80px;
    height: 40px;
    border: 1px solid #2ba3e7;
    background-color: transparent;
    border-radius: 10px;
    color: #999;
    font-family: "Comic Neue", cursive;
  }
  .join-btn:hover {
    cursor: pointer;
    background-color: #2ba3e7;
    color: #000;
  }
  .user-name {
    margin: 20px 80px;
    width: 240px;
    height: 40px;
    border-radius: 10px;
    background-color: transparent;
    border: 1px solid #ef5da8;
    color: #eef8f7;
    position: relative;
    font-family: "Comic Neue", cursive;
    top: -1vh;
    left: 0vw;
    text-align: center;
  }
  .user-name:focus {
    outline: none;
  }
`;

const Btn = styled.div`
  background-image: linear-gradient(
    to right,
    #ef5da8,
    #df72bc,
    #6ea5e5,
    #2ba3e7
  );
  width: 250px;
  border: none;
  border-radius: 15px;
  cursor: pointer;
  display: block;
  margin: 0 80px;
  text-align: center;
  padding: 15px 0;
  font-weight: 600;

  :active {
    color: #711a75;
  }
`;

const Main = (props) => {
  const history = useNavigate();
  const shortid = require("shortid");
  let textInput = React.createRef();
  let codeInput = React.createRef();
  const currentClass = shortid.generate();
  // const currentUser = uuidv4();
  console.log(currentClass);
  // useEffect(() => {

  //   socket.on('FE-error-user-exist', ({ error }) => {
  //     if (!error) {
  //       const roomName = currentClass;
  //       const userName = currentUser;

  //       sessionStorage.setItem('user', userName);
  //       history(`/room/${roomName}`);
  //     } else {
  //       setErr(error);
  //       setErrMsg('User name already exist');
  //     }
  //   });
  // }, [history]);

  function clickJoin() {
    const roomName = currentClass;
    const userName = textInput.current.value;
    console.log(userName);
    sessionStorage.setItem("user", userName);
    sessionStorage.setItem("isAdmin", userName);

    history(`/room/${roomName}`);
  }

  function joinMeet() {
    const roomName = codeInput.current.value;
    const userName = textInput.current.value;

    console.log(userName);
    sessionStorage.setItem("user", userName);
    history(`/room/${roomName}`);
  }

  return (
    <>
      <MainContainer>
        <div className="main-image">
          <img src={Image}></img>
        </div>
        <div className="main-details">
          <h2 className="main-title">
            Hello, This is a one stop video calling app for all your classworks,
            group study and team coding.
          </h2>
          <input
            className="user-name"
            ref={textInput}
            placeholder="Display name *"
          ></input>
          <Btn onClick={clickJoin}>New Meeting</Btn>
          {/* <Btn onClick={create} to= {"/room/:roomId"}>New Meeitng</Btn> */}
          <input
            className="main-input"
            ref={codeInput}
            placeholder="Enter meeitng link or code"
          ></input>
          <button className="join-btn" onClick={joinMeet}>
            JOIN
          </button>
        </div>
      </MainContainer>
    </>
  );
};

export default Main;
